module.exports = __webpack_public_path__ + "static/landing-page-demo-f17de10bcb71591a4f0b96f6d75188c0.png";